import { render, staticRenderFns } from "./LanguagesCloud.vue?vue&type=template&id=0a342a97&scoped=true"
import script from "./LanguagesCloud.vue?vue&type=script&lang=js"
export * from "./LanguagesCloud.vue?vue&type=script&lang=js"
import style0 from "./LanguagesCloud.vue?vue&type=style&index=0&id=0a342a97&prod&scoped=true&lang=css"
import style1 from "./LanguagesCloud.vue?vue&type=style&index=1&id=0a342a97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a342a97",
  null
  
)

export default component.exports